import React, { useEffect, useRef, useState } from "react";
// @ts-ignore
import ColorThief from "colorthief";

const proxyUrl = "https://corsproxy.io/?";

const CryptoImageWithBackground = ({ image, name, symbol, currentPrice, priceChange }) => {
  const [backgroundColor, setBackgroundColor] = useState("#FFEED9");
  const imgRef = useRef(null);

  useEffect(() => {
    const extractColor = () => {
      if (!imgRef.current) return;

      const imgElement = imgRef.current;

      if (imgElement.complete) {
        const colorThief = new ColorThief();
        try {
          const dominantColor = colorThief.getColor(imgElement);
          setBackgroundColor(
            `rgba(${dominantColor[0]}, ${dominantColor[1]}, ${dominantColor[2]}, 0.3)`
          );
        } catch (error) {
          console.error("Error extracting color:", error);
        }
      } else {
        imgElement.addEventListener("load", () => {
          const colorThief = new ColorThief();
          try {
            const dominantColor = colorThief.getColor(imgElement);
            setBackgroundColor(
              `rgba(${dominantColor[0]}, ${dominantColor[1]}, ${dominantColor[2]}, 0.3)`
            );
          } catch (error) {
            console.error("Error extracting color on load:", error);
          }
        });
      }
    };

    extractColor();
  }, [image]);

  return (
    <div
      className="crypto-item"
      style={{ backgroundColor }}
    >
      <div className="crypto-desc">
      <img
        className="crypto-img"
        src={`${proxyUrl}${image}`}
        alt={`${name} logo`}
        ref={imgRef}
        crossOrigin="anonymous"
      />
        <div className="crypto-symbol">{symbol} <br/> {name}</div> 
        <div className="crypto-name"></div>
      </div>
      <div className="crypto-info">
        <div className="crypto-info-price">
          <div className="crypto-current-price">${currentPrice}</div>
          <span
            className={`crypto-change ${
              priceChange < 0 ? "negative" : "positive"
            }`}
          >
            {priceChange}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default CryptoImageWithBackground;
